import { api, apiFile, base_url_v1, base_url_v2 } from "./api";



export const CompanyApi = async () => {
    let id = JSON.parse(String(localStorage.getItem('user'))).user.company.id
    const data = await api({ url: `${base_url_v2}company/companies/${id}`, method: "GET", token: true })
    return data;
}

export const EditCompanyApi = async (formRef: any, defualtDate: any, detailData:any ,isSelecetNewImage:boolean , cropData:any) => {
    let postData:any = {
        'name': formRef.current['name'].value,
        'phone': formRef.current['phone'].value,
        'establishment_date': defualtDate.start_date,
        'business_scope_id': formRef.current['activity'].value,
        'gender': formRef.current['gender'].value,
        'age': formRef.current['age'].value,
        'mobile': formRef.current['mobile'].value,
        'job_position_id': formRef.current['job'].value,
        'fname': formRef.current['nameBoss'].value,
        'lname': formRef.current['familyBoss'].value,
    }
    if(isSelecetNewImage == true && cropData != null){
        postData['logo'] = cropData ;
    }
    if(formRef.current['password'].value != ""){
        postData['password'] = formRef.current['password'].value ;
    }
    const data = await api({ url: `${base_url_v2}company/companies/${detailData.id}`, method: "PUT", token: true, body: JSON.stringify(postData) })
    return data;
}

export const BusinessScopesApi = async () => {
    const data = await api({ url: `${base_url_v2}company/business-scopes`, method: "GET", token: true })
    return data;
}

export const JobPositionsApi = async () => {
    const data = await api({ url: `${base_url_v2}company/job-positions`, method: "GET", token: true })
    return data;
}
